import React from 'react';
import Icon from '../icon';
import Button from '../button';

export interface CloseButtonProps {
	onClose: Function;
	closable?: boolean;
}

const CloseButton: React.FC<CloseButtonProps> = ({
	onClose,
	closable = true,
}) => {
	const handleClose = () => {
		if (closable) {
			onClose();
		}
	};

	return (
		<Button
			type="button"
			data-testid="button-modal-close"
			className="rounded-lg bg-cta hover:bg-cta-hover disabled:bg-cta-disabled"
			onClick={handleClose}
			disabled={!closable}>
			<span className="sr-only">Close</span>
			<Icon
				type="close"
				className="stroke-font-cta fill-transparent w-11 h-11"
				viewBox="0 0 44 44"
				aria-hidden="true"
			/>
		</Button>
	);
};

export default CloseButton;
